import { CircleCheck } from 'lucide-react';
import { Button, Badge } from 'twyne-new.ui';

import Connect from './Connect';

export default function Actions({ connected, onChange }) {
  if (!connected) {
    return <Connect onChange={onChange} />
  }

  return <>
    <div className='flex flex-col items-center gap-2'>
      <Badge color='success' className='mb-1' variant='outline'>
        <CircleCheck size={16} className='mr-1' />
        Connected
      </Badge>
      <Button color='danger' size='sm' block onClick={() => onChange(null)}>Disconnect</Button>
    </div>
  </>
}
